import { useState } from "react";
import { Reveal } from "@/components/Reveal";

const GHOST = "/products/the-ghost-in-your-bed-3.jpg";
const MATRY = "/products/matryoshka-skin-2.jpg";
const TOOTH = "/products/tooth-fairy-powder-2.jpg";

const ARTICLES = [
  {
    topic: "Dark Nostalgia",
    title: "Why the things that scared us still smell like home",
    excerpt: "On memory, fear and the strange comfort of the uncanny — and why we bottle it.",
    read: "6 min",
    image: GHOST,
  },
  {
    topic: "The Objects",
    title: "Giving a fragrance a face: the sculptural flacon",
    excerpt: "How each Beautifully Disturbed stopper is conceived as a collectible object first.",
    read: "5 min",
    image: MATRY,
  },
  {
    topic: "Rituals",
    title: "How to wear something a little bit frightening",
    excerpt: "Notes on scent, confidence and the art of being beautifully disturbed in public.",
    read: "4 min",
    image: TOOTH,
  },
];

const TOPICS = ["All", "Dark Nostalgia", "The Objects", "Rituals"];

export default function Journal() {
  const [topic, setTopic] = useState("All");
  const filtered = topic === "All" ? ARTICLES : ARTICLES.filter((a) => a.topic === topic);

  return (
    <div className="pt-32 md:pt-40 pb-24" data-testid="journal-page">
      <div className="container-lux">
        <Reveal>
          <p className="label-mono mb-6 text-blood">The Journal</p>
          <h1 className="heading-serif text-5xl md:text-7xl mb-8 leading-[0.95]">
            Midnight Dispatches
          </h1>
          <p className="max-w-xl text-base md:text-lg text-ivory/75 font-sans leading-relaxed">
            Essays on dark nostalgia, the craft of our sculptural flacons, and the beauty found in fear.
          </p>
        </Reveal>

        <div className="flex flex-wrap gap-3 mt-14 mb-16 border-b border-smoke/20 pb-8">
          {TOPICS.map((t) => (
            <button
              key={t}
              onClick={() => setTopic(t)}
              data-testid={`journal-filter-${t.toLowerCase().replace(/\s/g, "-")}`}
              className={`label-mono px-5 py-2.5 border transition-all duration-300 ${
                topic === t ? "border-blood text-blood" : "border-smoke/30 text-ivory/70 hover:border-ivory"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {filtered.map((a, i) => (
            <Reveal key={a.title} delay={(i % 3) * 0.1}>
              <article className="group cursor-pointer" data-testid="journal-article">
                <div className="overflow-hidden aspect-[4/3] mb-6 bg-ink">
                  <img
                    src={a.image}
                    alt={a.title}
                    className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                  />
                </div>
                <div className="flex justify-between items-center mb-3">
                  <span className="label-mono text-blood">{a.topic}</span>
                  <span className="label-mono text-smoke">{a.read}</span>
                </div>
                <h2 className="heading-serif text-2xl leading-snug mb-3 group-hover:text-blood transition-colors">
                  {a.title}
                </h2>
                <p className="text-sm text-ivory/65 font-sans leading-relaxed">{a.excerpt}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
